import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * A switch is an UI control for choosing between two choices. These two states are described with the boolean
 * property "toggleOn" - true is right state, false is left state.
 * What those choices are is tagged with labels that are left and right to the switch toggle itself.
 */
const Switch = (props) => {

    const toggleClass = classnames('switch-toggle', {
        'switch-toggle--right': props.toggleOn
    });

    const leftLabelClass  = `switch-container${props.toggleOn ? "--inactive" : "--active"}`;
    const rightLabelClass = `switch-container${props.toggleOn ? "--active" : "--inactive"}`;

    return (
        <div className="switch-container">
            <span className={leftLabelClass}>{props.leftLabel}</span>
            <div className="switch-control" onClick={props.onChange}>
                <div className={toggleClass} />
            </div>
            <span className={rightLabelClass}>{props.rightLabel}</span>
        </div>
    );
};

Switch.propTypes = {
    /**
     * whether the switch is on or off (on=right off=left)
     */
    toggleOn: PropTypes.bool.isRequired,

    /**
     * change handler
     */
    onChange: PropTypes.func.isRequired,

    /**
     * the label left to the switch
     */
    leftLabel: PropTypes.node,

    /**
     * the label right to the switch
     */
    rightLabel: PropTypes.node
};

export default Switch;